<script setup>
import { computed } from 'vue';

const props = defineProps({
  logomarca: {
    type: String,
    default: ''
  },
  fabricante: {
    type: String,
    default: ''
  },
  width: {
    type: Number,
    default: 300
  },
  height: {
    type: Number,
    default: null
  }
});

// URL base para imagens - usando a variável de ambiente
const urlBaseImagens = computed(() => import.meta.env.TMKT_LEGADO_URL || 'https://tmkt-php8.precodogas.com.br');

// Formatar URL da logo do fabricante
const logoUrl = computed(() => {
  if (!props.logomarca) return '';
  return `${urlBaseImagens.value}/marcas/${props.logomarca}`;
});

// Calcular se existe uma logo válida para exibir
const temLogo = computed(() => !!props.logomarca);

const calculatedHeight = computed(() => {
  if (props.height) return props.height;
  // Para 225:50, altura = largura / 4.5
  return Math.round(props.width / 4.5);
});
</script>

<template>
  <div 
    class="marca-logo-container"
    :style="{ width: `${width}px`, height: `${calculatedHeight}px` }"
  >
    <v-img
      v-if="temLogo"
      :src="logoUrl"
      :alt="fabricante"
      :width="width"
      :height="calculatedHeight"
      class="marca-logo"
      contain
      eager
      @error="$emit('logo-error')"
    />
    <span v-else class="marca-texto">{{ fabricante }}</span>
  </div>
</template>

<style scoped>
.marca-logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  position: relative;
}

.marca-logo {
  object-fit: contain;
  max-width: 100%;
  max-height: 100%;
}

.marca-texto {
  font-weight: 500;
  font-size: 0.95rem;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  padding: 0 4px;
}
</style>
